import { ButtonCellrendererComponent } from './../../../shared/common-components/ag-grid/button-cellrenderer/button-cellrenderer.component';
import { CheckboxCellrenderComponent } from './../../../shared/common-components/ag-grid/checkbox-cellrender/checkbox-cellrender.component';
import { TextSvgCellrenderComponent } from './../../../shared/common-components/ag-grid/text-svg-cellrender/text-svg-cellrender.component';
import { CustomHeaderComponent } from './../../../shared/common-components/ag-grid/custom-header/custom-header.component';
import { AgColDefsI, AgGridI } from './../../../shared/common-components/ag-grid/ag-grid.model';
import { ImageRendererComponent } from 'src/app/shared/common-components/ag-grid/image-renderer/image-renderer.component';
import { TextRendererComponent } from 'src/app/shared/common-components/ag-grid/text-renderer/text-renderer.component';
import { paginationModel } from 'src/app/shared/models/common.model';
import { WhatsappIconRendererComponent } from 'src/app/shared/common-components/ag-grid/whatsapp-icon-renderer/whatsapp-icon-renderer.component';
import { EmailIconRendererComponent } from 'src/app/shared/common-components/ag-grid/email-icon-renderer/email-icon-renderer.component';
import { PdfIconRendererComponent } from 'src/app/shared/common-components/ag-grid/pdf-icon-renderer/pdf-icon-renderer.component';
import { AmountColWidth, BillNoColWidth, CheckboxColWidth, ContactColWidth, DateColWidth, InfoDataColWidth, NameColWidth, StatusColWidth } from '../../../shared/enum/common-enum';
import { CommonIconsComponent } from '../../../shared/common-components/ag-grid/common-icons/common-icons.component';

export class SubscriptionList extends paginationModel {
  planTypeId: number = 2;
  planId: string = "";
  statusId: number = -1;
  isActive: number | string = 0;
  userId: string = "";
  subscriptionId: string = "";
  cityIds: any;
  expiredDate: String;
  cityName: any = [];
  amount: number = 0;
  salesPerson: string;
  searchFilter: any;
  statusValue: any;
  generateBill: any;
  fromDate: string = null;
  toDate: string = null;
}


const ImageColumn: AgColDefsI = {
  headerName: "",
  field: 'photoUrl',
  minWidth: 50,
  sortable: true,
  editable: false,
  resizable: false,
  cellRenderer: ImageRendererComponent
};
const NameColumn: AgColDefsI = {
    headerName: "Name", 
    field: 'shopName', 
    headerComponent: CustomHeaderComponent,
    minWidth: NameColWidth.minWidth,
    maxWidth: NameColWidth.maxWidth,
    sortable: true,
    editable:false,
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRendererParams :{isCursor:true,textPrimary:true,isAddressAvailable:true},
    cellRenderer:TextRendererComponent
  };
  const BillNo: AgColDefsI = {
    headerName: "Bill No.", 
    field: 'billSeriesNo', 
    minWidth: BillNoColWidth.minWidth,
    maxWidth: BillNoColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer:TextRendererComponent,
    cellRendererParams :{isCursor:true,isBillNoClick:true},
  };

  const ContactColumn: AgColDefsI = {
    headerName: "Contact", 
    field: 'contactNo', 
    minWidth: ContactColWidth.minWidth,
    maxWidth: ContactColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
   
    cellRenderer:TextRendererComponent
  };
  const GstNoColumn: AgColDefsI = {
    headerName: "GST No.", 
    field: 'gstTrn', 
    minWidth: 150,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer:TextRendererComponent
  };

  const Status: AgColDefsI = {
    headerName: "Plan Type", 
    field: 'planTypeName', 
    minWidth: StatusColWidth.minWidth,
    maxWidth: StatusColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer:TextRendererComponent
  };

  const PlanNameColumn: AgColDefsI = {
    headerName: "Plan Name", 
    field: 'planName', 
    minWidth: 120,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer:TextRendererComponent
  };
  const RenewalStartDateColumn: AgColDefsI = {
    headerName: "Renewal Start Dt", 
    field: 'renewalStartDate', 
    minWidth: DateColWidth.minWidth,
    maxWidth: DateColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    editable:false,
    cellRenderer: TextSvgCellrenderComponent,
  };
  const ExpiryDateColumn: AgColDefsI = {
    headerName: "Expiry Dt", 
    field: 'expiredDate', 
    minWidth: DateColWidth.minWidth,
    maxWidth: DateColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer: TextSvgCellrenderComponent,
    lockPinned:true, 
    lockPosition:'right',

  };
  const AmountColumn: AgColDefsI = {
    headerName: "Amount", 
    field: 'finalAmt', 
    minWidth: AmountColWidth.minWidth,
    maxWidth: AmountColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
    headerClass: "px-1 ag_header_end custom-column-group-cell",
    cellClass: " ag_cell_end custom-column-group-cell",
    cellRenderer:TextRendererComponent
  };
  const PaidColumn: AgColDefsI = {
    headerName: "Paid", 
    field: 'totalPaid', 
    minWidth: AmountColWidth.minWidth,
    maxWidth: AmountColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
    headerClass: "px-1 ag_header_end custom-column-group-cell",
    cellClass: " ag_cell_end custom-column-group-cell",
    cellRenderer:TextRendererComponent
  };
  const BalanceColumn: AgColDefsI = {
    headerName: "Balance", 
    field: 'balanceAmount', 
    minWidth: AmountColWidth.minWidth,
    maxWidth: AmountColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
    headerClass: "px-1 ag_header_end custom-column-group-cell",
    cellClass: " ag_cell_end custom-column-group-cell",
    cellRenderer:TextRendererComponent
  };
  const SoftConstColumn: AgColDefsI = {
    headerName: "Soft. Cost", 
    field: 'amount', 
    minWidth: 150,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
  };
  const StatusName: AgColDefsI = {
    headerName: "Status", 
    field: 'statusName', 
    minWidth: StatusColWidth.minWidth,
    maxWidth: StatusColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer:TextRendererComponent
  };
  const RenewalChargeColumn: AgColDefsI = {
    headerName: "Renewal Charge", 
    field: 'renewalCharge', 
    minWidth: InfoDataColWidth.minWidth,
    maxWidth: InfoDataColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    headerComponentParams:{
      label: 'Renewal Charge'
    },
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell ag_header_center",
    cellClass: "custom-column-group-cell d-flex align-items-center justify-content-center",
    cellRenderer: CheckboxCellrenderComponent,
  };
  const ActiveColumn: AgColDefsI = {
    headerName: "Active", 
    field: 'isActive', 
    minWidth: StatusColWidth.minWidth,
    maxWidth: StatusColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
     headerClass: "custom-column-group-cell ag_header_center",
    cellClass: "custom-column-group-cell d-flex align-items-center justify-content-center ",
    sortable: false,
    editable:false,
    cellRenderer: CheckboxCellrenderComponent,
    cellRendererParams:{disabled : true},
  };
  const genrateBillNoColumn: AgColDefsI = {
    headerName: "Genrate Bill No.", 
    field: 'genrateBillNo', 
    minWidth: BillNoColWidth.minWidth,
    maxWidth: BillNoColWidth.maxWidth,
    headerComponent: CustomHeaderComponent,
    sortable: true,
    editable:false,
     headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellRenderer: ButtonCellrendererComponent,
    cellRendererParams :{genrateBillNo:true},
  };
  const CheckboxColumn: AgColDefsI = {
    headerName: "", 
    field:'',
    minWidth: CheckboxColWidth.minWidth,
    sortable: true,
    editable:false,
    resizable:false,
    headerClass:'custom-column-group-cell',
    cellClass: 'mx-0 p-0 d-flex align-items-center justify-content-center custom-column-group-cell',
    cellRenderer:CheckboxCellrenderComponent,
    maxWidth: CheckboxColWidth.maxWidth,
    pinned: 'left',
    lockPinned:true,
    lockPosition:'left',
  };
  const Action: AgColDefsI = {
    headerName: "", 
    field: '', 
    maxWidth: StatusColWidth.maxWidth,
    minWidth: StatusColWidth.minWidth,
    sortable: false,
    editable:false,
    headerComponentParams: { enableMenu: false },
    cellRenderer: CommonIconsComponent, 
    cellRendererParams: {
      EmailIcon:true,
      WhatsappIcon:true,
      PdfIcon:true
    },
    pinned: 'right',
    headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
    cellStyle:'cursor-pointer',
    lockPinned:true,
    lockPosition:'right',
   
    
    
  };
  const Action1: AgColDefsI = {
    headerName: " ", 
    field: '', 
    maxWidth:35,
    sortable: false,
    editable:false,
    headerClass:'',
    cellRenderer: WhatsappIconRendererComponent,
    pinned: 'right',
    lockPinned:true,
    lockPosition:'right',
  };


const Action2: AgColDefsI = {
  headerName: "",
  field: '',
  maxWidth: 35,
  sortable: false,
  editable: false,
  headerClass: '',
  cellRenderer: PdfIconRendererComponent,
  pinned: 'right',
  lockPinned: true,
  lockPosition: 'right',

};

const Mail: AgColDefsI = {
  headerName: "Mail",
  field: 'email',
  headerComponent: CustomHeaderComponent,
  minWidth: 250,
  sortable: true,
  editable: false,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell",
  cellRendererParams: { isCursor: true },
  cellRenderer: TextRendererComponent
};
const City: AgColDefsI = {
  headerName: "City",
  field: 'addressLine2',
  headerComponent: CustomHeaderComponent,
  minWidth: 120,
  sortable: true,
  editable: false,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell",
  cellRendererParams: { isCursor: true },
  cellRenderer: TextRendererComponent
};


export const SubscriptionListColumnDef: AgColDefsI[] = [
  CheckboxColumn,
  // ImageColumn,
  NameColumn,
  ContactColumn,
  Mail,
  City,
  GstNoColumn,
  Status,
  PlanNameColumn,
  RenewalStartDateColumn,
  ExpiryDateColumn,
  StatusName,
  AmountColumn,
  PaidColumn,
  BalanceColumn,
  // SoftConstColumn ,
  RenewalChargeColumn,
  BillNo,
  ActiveColumn,
  Action,
  genrateBillNoColumn,

  // Action1,
  // Action2

]
export const AgGridDataModelSubscriptionList: AgGridI = {
  colDefs: SubscriptionListColumnDef,
  rowSelection: "multiple",
  rowHeight: 40,
}

export class UserFormBillDetails{
    id:any;
    billDate:any;
    billSeries:any;
    billNo!:number;
    amount!:number;
    discount!:number;
    netAmount!:number;
    tax!:number;
    finalAmt!:number;
    reverseAmt!:number;
    // password?:any;
}